const tours = {
  availableEscapes: "Verfügbare Fluchten", // translated
  addOns: "Add-Ons", // translated
  selectRoom: "Wählen Sie einen Raum aus", // translated
  tour: "Tour", // translated
  availableExperiences: "Verfügbare Erfahrungen", // translated
  getRequest: "Anfrage abrufen", // translated
  addOn: "Hinzufügen Auf", // translated
  tours: "Touren", // translated
  sendRequest: "Anfrage senden", // translated
};


export default tours;
